export const viewModelMetadataKey = 'viewModelInstance';

export function viewmodel(): any {
  return Reflect.metadata(viewModelMetadataKey, {});
}
